var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 450 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.744 0L66.3401 217.975L0 540.198L224.744 676.94L449.488 540.198L381.794 216.621L224.744 0ZM36.5548 525.305L86.6483 280.253L200.374 625.493L36.5548 525.305ZM102.895 224.744L224.744 56.863L346.593 224.744L224.744 592.999L102.895 224.744ZM247.76 625.493L361.486 280.253L411.579 525.305L247.76 625.493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEos);
export default __webpack_public_path__ + "static/media/eos.240087ca6e3e8cbf5a4c85e95013e4cb.svg";
export { ForwardRef as ReactComponent };